import { PricingType } from '@/inquiries/models/pricing-type'

export default class Pricing {
  public type: PricingType = PricingType.AllIn
  public amount: number | null = null
}
